import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';



const LoadingApp = () => {

	return (
		<div className="lfmt-loading loading-app">
			
			<FontAwesomeIcon className="loading-icon fa-spin" icon={faSpinner} />

		</div>
	);
};

export default LoadingApp;